import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const carouselData = [
  {
    image: process.env.PUBLIC_URL + "/assets/WEBSITE IMAGES/homecarousol/7.jpg",
    title: "Host Your Event With Us",
    description:
      "Make your events unforgettable with our top-tier sports facilities, whether it's a corporate event, or sports tournament, ensuring an action-packed experience",
  },
  {
    image: "/assets/WEBSITE IMAGES/homecarousol/19.jpg",
    title: "Train Your child for better future",
    description:
      "Give your child the best start in sports with expert coaching and a supportive environment, helping them develop skills, discipline, and a winning mindset",
  },
  {
    image: "/assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/03.png",
    title: "Expertly Organized",
    description:
      "Join well-organized tournaments led by experienced professionals, compete at the highest level, showcase your skills.",
  },
];

const EventCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselData.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + carouselData.length) % carouselData.length
    );
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full overflow-hidden">
      {/* Mobile View */}
      <div className="block md:hidden">
        <div className="flex flex-col space-y-6 p-4">
          <div className="relative w-full h-[400px] rounded-2xl overflow-hidden">
            <img
              src={carouselData[currentSlide].image}
              alt="Event venue"
              className="w-full h-full object-cover transition-opacity duration-500"
            />
          </div>
          <div className="space-y-4 text-center">
            <h1 className="text-4xl font-bold tracking-tight">
              {carouselData[currentSlide].title}
            </h1>
            <p className="text-lg text-gray-600">
              {carouselData[currentSlide].description}
            </p>
            {/* <button className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
              CONTACT US
              <ChevronRight className="ml-2 h-5 w-5" />
            </button> */}
          </div>
        </div>
      </div>

      {/* Desktop View */}
      <div className="hidden md:block">
        <div className="grid grid-cols-2 min-h-[600px]">
          {/* Left Content */}
          <div className="flex flex-col justify-center p-12 space-y-6">
            <h1 className="text-6xl font-bold tracking-tight leading-tight">
              {carouselData[currentSlide].title}
            </h1>
            <p className="text-lg text-gray-600 max-w-xl">
              {carouselData[currentSlide].description}
            </p>
            {/* <div>
              <button className="inline-flex items-center px-8 py-3 border-2 border-black rounded hover:bg-gray-100 transition-colors">
                CONTACT US
                <ChevronRight className="ml-2 h-5 w-5" />
              </button>
            </div> */}
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="h-full">
              <img
                src={carouselData[currentSlide].image}
                alt="Event venue"
                className="w-full h-full object-cover transition-opacity duration-500"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Buttons */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 p-2  rounded-full shadow-lg hover:bg-white transition-colors"
      >
        <ChevronLeft className="h-6 w-6" />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 p-2  rounded-full shadow-lg hover:bg-white transition-colors z-10"
      >
        <ChevronRight className="h-6 w-6" />
      </button>

      {/* Slide Indicators */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
        {carouselData.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-colors ${
              currentSlide === index ? "bg-blue-600" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default EventCarousel;
